"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = newOutput;

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function newOutput() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultAspectRatio = _ref.defaultAspectRatio,
      defaultDuration = _ref.defaultDuration,
      isMaster = _ref.isMaster,
      video = _ref.video;

  return {
    outputId: (0, _v.default)(),
    aspectRatio: defaultAspectRatio || 'WIDE',
    latestVersion: 1,
    status: {
      name: 'DRAFT'
    },
    versions: [{
      appliedAddons: {
        DURATION: {
          value: defaultDuration || 'STANDARD'
        }
      },
      versionNumber: 1,
      versionId: (0, _v.default)(),
      dueDate: null
    }],
    isMaster: Boolean(isMaster),
    isNew: true,
    notes: '',
    videoId: '',
    readableId: '',
    video: video
  };
}